import {
    PRESENCE_ENTER,
    PRESENCE_LEAVE,
    PRESENCE_OVERRIDE,
    type PresenceActionTypes,
    type PresenceEnterAction,
    type PresenceLeaveAction,
    type PresenceOverrideAction,
    type PresenceState,
} from "../../Actions/General/PresenceActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function removeFromPresence(presence: PresenceState, action: PresenceLeaveAction): PresenceState {
    const newPresence = [];

    for(let i = 0, l = presence.length; i < l; i++) {
        if(presence[i].clientId === action.member.clientId) {
            if(presence[i].connectionId === action.member.connectionId) {
                continue;
            }
        }

        newPresence.push(presence[i]);
    }

    return newPresence;
}

function addPresence(state: PresenceState, action: PresenceEnterAction): PresenceState {
    const split = action.member.clientId.split("|");
    let outlet: string | boolean = split[0];
    let register: string | boolean = split[1];

    if(!outlet || outlet === "false") {
        outlet = false;
    }

    if(!register || register === "false") {
        register = false;
    }

    return [
        ...state,
        {
            clientId    : action.member.clientId,
            connectionId: action.member.connectionId,
            outlet,
            register,
        },
    ];
}

function overridePresence(state: PresenceState, action: PresenceOverrideAction): PresenceState {
    const members = [];

    for(let i = 0, l = action.members.length; i < l; i++) {
        const split = action.members[i].clientId.split("|");
        let outlet: string | boolean = split[0];
        let register: string | boolean = split[1];

        if(!outlet || outlet === "false") {
            outlet = false;
        }

        if(!register || register === "false") {
            register = false;
        }

        members.push({
            clientId    : action.members[i].clientId,
            connectionId: action.members[i].connectionId,
            outlet,
            register,
        });
    }

    return members;
}

export default function PresenceReducer(
    state: PresenceState | undefined,
    action: ShopfrontActions<PresenceActionTypes>
): PresenceState {
    if(typeof state === "undefined") {
        return [];
    }

    switch(action.type) {
        case PRESENCE_ENTER:
            return addPresence(state, action);
        case PRESENCE_LEAVE:
            return removeFromPresence(state, action);
        case PRESENCE_OVERRIDE:
            return overridePresence(state, action);
    }

    return state;
}
